"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumn = exports.Table = void 0;
var tslib_1 = require("tslib");
var Table_1 = require("./Table");
Object.defineProperty(exports, "Table", { enumerable: true, get: function () { return tslib_1.__importDefault(Table_1).default; } });
Object.defineProperty(exports, "TableColumn", { enumerable: true, get: function () { return Table_1.TableColumn; } });
tslib_1.__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map